








































import {Component, Mixins, Prop, Vue} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import {SVGPie} from "@/mixin/imports";
import SVGPieMixin from "@/mixin/SVGPie.vue";
import * as firebase from 'firebase/app';
import Starred from "@/components/Starred.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import {debounce} from "vee-validate/dist/types/utils";

@Component({
    components: {
        Starred,
        ConfirmModal
    },
    computed: {
        ...mapGetters({profile: 'profile', isCompany: 'isCompany'})
    },
    name: "CompanyWorker",
})
export default class CompanyWorker extends Mixins<SVGPie>(SVGPieMixin) {
    @Prop(Object) private readonly worker!: any;
    @Prop({type: Boolean, default: false}) private readonly show_actions!: boolean;

    private profile?: any;
    private isCompany?: boolean;

    get isStarred() {
        return this.isCompany && this.profile?.starredWorkers && (this.profile.starredWorkers as string[]).indexOf(this.worker.id) > -1
    }

    get makePie() {
        if (this.worker) {
            return this.makePiePath(this.worker.settori.map((a: number) => {
                return {
                    amount: 1,
                    dataSettore: a
                }
            }), 0.5, 0)
        }
        return ``
    }

    private toggleStarred(announcementUuid: string) {
        let starredWorkers: string[] = this.profile?.starredWorkers || [];

        if (starredWorkers.indexOf(announcementUuid) === -1) {
            starredWorkers.push(announcementUuid)
        } else {
            for (let i = starredWorkers.length - 1; i >= 0; i--) {
                if (starredWorkers[i] === announcementUuid) {
                    starredWorkers.splice(i, 1);
                }
            }
        }
        firebase.firestore().collection('users')
            .doc(this.profile.id).update({starredWorkers: starredWorkers})
    }

    private openWorker() {
        this.$router.push({
            name: 'Worker', params: {
                workerUuid: this.worker.id
            }
        })
    }
}

